module.exports = { 
      attributes: {"title":"Attachment","language":"en","slug":"anhang"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = function render() { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0) };
            this.$options.staticRenderFns = [function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('p',[_vm._v("Below is a list of resources used from external sources\nincluding their license terms")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://www.flaticon.com/free-icon/cherry-blossom_774832"}},[_vm._v("Icon")]),_vm._v("\ndesigned by "),_c('a',{attrs:{"href":"https://www.freepik.com"}},[_vm._v("Freepik")]),_vm._v(" from "),_c('a',{attrs:{"href":"https://www.flaticon.com"}},[_vm._v("Flaticon")]),_vm._v("\n("),_c('a',{attrs:{"href":"https://file000.flaticon.com/downloads/license/license.pdf"}},[_vm._v("Lizenz")]),_vm._v(")\n(last call on July 4, 2018)")]),_vm._v(" "),_c('li',[_vm._v("Logo designed by Plamen Petrov (Facebook \"plamen.petroff.1\")")])])]) }];
          }
        }
      },
     }